import { Base } from "../../framework/base";
import { IdTitle, IIdTitle } from "../common/idTitle";
import { IWhistleBlowChannelEditItem, WhistleBlowChannelEditItem } from "./whistleBlowChannelEditItem";
import { IWhistleBlowChannelEditResourceItem, WhistleBlowChannelEditResourceItem } from "./whistleBlowChannelEditResourceItem";

export interface IWhistleBlowChannelEdit {
    whistleBlowApplicationUrl: string;
    whistleBlowChannel: IWhistleBlowChannelEditItem;
    resources: IWhistleBlowChannelEditResourceItem[];
    cultures: IIdTitle[];
}

export class WhistleBlowChannelEdit implements IWhistleBlowChannelEdit {
    whistleBlowApplicationUrl: string;
    whistleBlowChannel: WhistleBlowChannelEditItem;
    resources: WhistleBlowChannelEditResourceItem[];
    cultures: IdTitle[];

    constructor();
    constructor(obj: IWhistleBlowChannelEdit);
    constructor(obj?: any) {
        this.whistleBlowApplicationUrl = obj && obj.whistleBlowApplicationUrl || "";
        this.whistleBlowChannel = new WhistleBlowChannelEditItem(obj ? obj.whistleBlowChannel : null);
        this.resources = Base.getTypedArray(obj ? obj.resources : null, WhistleBlowChannelEditResourceItem);
        this.cultures = Base.getTypedArray(obj ? obj.cultures : null, IdTitle);
    }
}